import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { Button, useTheme } from "capsule"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet, View } from "react-native"
import { Text } from "react-native-paper"

import { RoleOrPracticioner } from "../../common/CommonUserData"
import { RegisterPracticianWorkflowNS } from "../../features/i18n/constants"
import { OnboardingParamList } from "../../features/Navigation/types"
import { useRole } from "../../features/Providers/RoleProvider"

const workflows: Array<{ role: RoleOrPracticioner; link: keyof OnboardingParamList }> = [
  { role: "kine", link: "RegisterCgu" },
  { role: "surgeon", link: "RegisterCgu" },
  { role: "gp", link: "RegisterCgu" },
  { role: "patient", link: "RegisterCodeAlreadyUsed" },
]

const RegisterPracticianWorkflowScreen = () => {
  const {
    colors: {
      surface: { background },
    },
    dimensions: { spacing },
  } = useTheme()
  const { t } = useTranslation(RegisterPracticianWorkflowNS)
  const { setRole } = useRole()
  const navigation = useNavigation<StackNavigationProp<OnboardingParamList>>()
  const s = useMemo(
    () => ({
      view: [
        styles.view,
        {
          backgroundColor: background,
          paddingHorizontal: spacing * 2,
        },
      ],
      section: styles.section,
      bold: styles.bold,
      button: styles.button,
    }),
    [background, spacing],
  )
  const handleWorkflowRedirect = (
    choosenRole: RoleOrPracticioner,
    link: keyof OnboardingParamList,
  ) => {
    setRole?.(choosenRole)
    // @ts-ignore
    navigation.navigate(link)
  }
  return (
    <View style={s.view}>
      <View style={s.section}>
        <Text style={s.bold}>{t("codeAlreadyUsed")}</Text>
        <Text>{t("chooseYourRole")}</Text>
      </View>
      <View style={s.section}>
        {workflows.map(({ role, link }) => (
          <Button
            key={role}
            style={s.button}
            onPress={() => {
              handleWorkflowRedirect(role, link)
            }}
          >
            {t(role)}
          </Button>
        ))}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    paddingVertical: 40,
    gap: 40,
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
  },
  section: {
    gap: 8,
    alignItems: "flex-start",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  bold: {
    fontWeight: "bold",
  },
  button: {
    width: "100%",
    height: 40,
  },
})

export default RegisterPracticianWorkflowScreen
